import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dd2212c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "point-chart" }
const _hoisted_2 = { class: "datetime-select" }
const _hoisted_3 = {
  class: "point-chart",
  ref: "chartRef"
}
const _hoisted_4 = { style: {"color":"#007ba6"} }
const _hoisted_5 = {
  key: 0,
  style: {"font-size":"12px","color":"#e46708"}
}
const _hoisted_6 = { class: "unit" }
const _hoisted_7 = { class: "unit" }
const _hoisted_8 = { style: {"display":"flex","justify-content":"center","align-items":"center","height":"10px","margin-top":"25px"} }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#497ddf","margin-left":"10px"} }, "正在同步数据", -1))
const _hoisted_11 = { class: "unit" }
const _hoisted_12 = { class: "unit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startTime = 12)),
        type: _ctx.startTime === 12 ? 'primary' : ''
      }, {
        default: _withCtx(() => [
          _createTextVNode("最近一年")
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startTime = 6)),
        type: _ctx.startTime === 6 ? 'primary' : ''
      }, {
        default: _withCtx(() => [
          _createTextVNode("最近6个月")
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startTime = 1)),
        type: _ctx.startTime === 1 ? 'primary' : ''
      }, {
        default: _withCtx(() => [
          _createTextVNode("最近1个月")
        ]),
        _: 1
      }, 8, ["type"])
    ]),
    _createElementVNode("div", _hoisted_3, null, 512),
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "基础配置" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions, {
              column: 2,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "名称：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "分组：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail.group?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "采集终端：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail.sensor?.terminal?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "电量：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail.data?.raw?.battery) + "% ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "传感器：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail.sensor?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "最新采集时间：" }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", _hoisted_4, _toDisplayString(_ctx.moment(_ctx.detail.data?.collectTime).format('YYYY-MM-DD HH:mm:ss')), 1),
                    (Date.now() - new Date(_ctx.detail.data?.collectTime).getTime() > 24 * 60 * 60 * 1000)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "（ 设备可能掉线 ）"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "单位：" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      "allow-create": "",
                      filterable: "",
                      modelValue: _ctx.detail.unit,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detail.unit) = $event)),
                      placeholder: "修改单位",
                      style: {"width":"120px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                { label: 'με', value: 'με' },
                { label: 'MPa', value: 'MPa' },
                { label: 'kN', value: 'kN' },
                { label: 'm', value: 'm' },
                { label: 'cm', value: 'cm' },
                { label: 'mm', value: 'mm' },
            ], (item) => {
                          return _createVNode(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.data?.raw?.data, (item) => {
                  return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                    key: item.key,
                    label: _ctx.detail.label[item.key]
                  }, {
                    label: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        style: {"max-width":"130px"},
                        modelValue: _ctx.detail.label[item.key],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.detail.label[item.key]) = $event),
                        modelModifiers: { trim: true }
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.value) + " ", 1),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(item.unit || _ctx.detail.unit), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128)),
                _createVNode(_component_el_descriptions_item, { label: "监测状态：" }, {
                  default: _withCtx(() => [
                    (_ctx.detail.data?.warning)
                      ? (_openBlock(), _createBlock(_component_el_text, {
                          key: 0,
                          type: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.detail.data?.warning), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_text, {
                          key: 1,
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("正常")
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                (!(_ctx.detail.data?.raw?.data.length % 2))
                  ? (_openBlock(), _createBlock(_component_el_descriptions_item, { key: 0 }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.warning, (level, k) => {
                  return (_openBlock(), _createElementBlock("div", { key: k }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level, (items, ck) => {
                      return (_openBlock(), _createElementBlock("div", { key: ck }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                          return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                            key: item.key,
                            label: item.label + '：'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                modelValue: item.value,
                                "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                controls: false
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.detail.unit), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _createVNode(_component_el_icon, {
                      color: "#409EFC",
                      class: "is-loading"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Loading)
                      ]),
                      _: 1
                    }),
                    _hoisted_10
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_collapse_item, { title: "日志配置" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions, {
              column: 2,
              border: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.report?.data, (item) => {
                  return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                    key: item.key,
                    label: _ctx.detail.label[item.key] + '变化率'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.value) + " ", 1),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(item.unit || _ctx.detail.unit), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128)),
                _createVNode(_component_el_descriptions_item, { label: "状态：" }, {
                  default: _withCtx(() => [
                    (_ctx.detail.report?.log)
                      ? (_openBlock(), _createBlock(_component_el_text, {
                          key: 0,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.detail.report?.log), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_text, {
                          key: 1,
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("正常")
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "生成时间：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail.report?.stamp ? _ctx.moment(_ctx.detail.report?.stamp).format('YYYY-MM-DD HH:mm:ss') : '-'), 1)
                  ]),
                  _: 1
                }),
                (_ctx.detail.report?.interval)
                  ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                      key: 0,
                      label: _ctx.detail.report?.interval?.label + '：'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.detail.report.interval.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.detail.report.interval.value) = $event)),
                          controls: false
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (_ctx.detail.report?.time)
                  ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                      key: 1,
                      label: _ctx.detail.report?.time?.label + '：'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_time_select, {
                          style: {"width":"120px"},
                          modelValue: _ctx.detail.report.time.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detail.report.time.value) = $event)),
                          start: "00:30",
                          step: "00:30",
                          end: "23:30"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (_ctx.detail.data?.raw?.data.length % 2)
                  ? (_openBlock(), _createBlock(_component_el_descriptions_item, { key: 2 }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.report?.warning, (level, k) => {
                  return (_openBlock(), _createElementBlock("div", { key: k }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level, (items, ck) => {
                      return (_openBlock(), _createElementBlock("div", { key: ck }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                          return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                            key: item.key,
                            label: item.label + '：'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                modelValue: item.value,
                                "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                controls: false
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.detail.unit), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}